'use es6';

import MatchDataType from 'customer-data-filters/components/propTypes/MatchDataType';
import UIIconCircle from 'UIComponents/icon/UIIconCircle';
import { OLAF } from 'HubStyleTokens/colors';
import { jsx as _jsx } from "react/jsx-runtime";
const MatchStatusIconCircle = props => {
  const {
    matchData
  } = props;
  if (!matchData) {
    return null;
  }
  return /*#__PURE__*/_jsx(UIIconCircle, {
    backgroundColor: matchData.iconColor,
    borderWidth: 0,
    color: OLAF,
    name: matchData.icon,
    padding: 0.25,
    size: 10,
    style: {
      marginRight: '2px'
    },
    verticalAlign: 'text-top'
  });
};
MatchStatusIconCircle.propTypes = {
  matchData: MatchDataType
};
export default MatchStatusIconCircle;